/* RESPONSIBLE TEAM: team-automation-foundations */
import type ClassifyConversationAttribute from 'embercom/models/operator/visual-builder/step/classify-conversation-attribute';
import StepConfig, { type StepConfigParams } from '../step';

export default class ClassifyConversationAttributeConfiguration extends StepConfig {
  declare step: ClassifyConversationAttribute;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/classify-conversation-attribute',
      ...params,
    });
  }
}
